import { render, staticRenderFns } from "./kpi-summary.vue?vue&type=template&id=b0b21c66&scoped=true"
import script from "./kpi-summary.vue?vue&type=script&lang=js"
export * from "./kpi-summary.vue?vue&type=script&lang=js"
import style0 from "./kpi-summary.vue?vue&type=style&index=0&id=b0b21c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b21c66",
  null
  
)

export default component.exports